import React from "react";
import { cn } from "@/lib/utils";

const MAP = {
  draft: "bg-slate-100 text-slate-700 border-slate-200",
  ai_generated: "bg-indigo-100 text-indigo-700 border-indigo-200",
  pending_approval: "bg-amber-100 text-amber-800 border-amber-200",
  scheduled: "bg-blue-100 text-blue-800 border-blue-200",
  published: "bg-green-100 text-green-800 border-green-200",
  failed: "bg-red-100 text-red-800 border-red-200",
  cancelled: "bg-slate-100 text-slate-500 border-slate-200",
  suspended: "bg-red-100 text-red-800 border-red-200",
  active: "bg-green-100 text-green-800 border-green-200",
  trial: "bg-purple-100 text-purple-800 border-purple-200",
  expired: "bg-slate-100 text-slate-600 border-slate-200",
  // sentiment
  positive: "bg-green-100 text-green-700 border-green-200",
  neutral: "bg-slate-100 text-slate-600 border-slate-200",
  negative: "bg-red-100 text-red-700 border-red-200",
  // priority
  normal: "bg-slate-100 text-slate-600 border-slate-200",
  important: "bg-amber-100 text-amber-800 border-amber-200",
  urgent: "bg-red-100 text-red-700 border-red-200",
  // payment
  paid: "bg-green-100 text-green-800 border-green-200",
  unpaid: "bg-red-100 text-red-700 border-red-200",
  // reply status
  none: "bg-slate-100 text-slate-600 border-slate-200",
  approved: "bg-blue-100 text-blue-800 border-blue-200",
  rejected: "bg-red-100 text-red-700 border-red-200",
  // connection
  connected: "bg-green-100 text-green-800 border-green-200",
  not_connected: "bg-slate-100 text-slate-600 border-slate-200",
};

const LABELS = {
  ai_generated: "AI Generated",
  pending_approval: "Pending Approval",
  not_connected: "Not Connected",
};

export default function StatusBadge({ status, className }) {
  const key = (status || "").toLowerCase();
  const label = LABELS[key] || (status || "").replace(/_/g, " ");
  return (
    <span
      data-testid={`status-badge-${key}`}
      className={cn(
        "inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-semibold capitalize",
        MAP[key] || "bg-slate-100 text-slate-600 border-slate-200",
        className
      )}
    >
      {label}
    </span>
  );
}
